import { forwardRef } from 'react'

const BASE =
  'inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-medium ' +
  'transition-all whitespace-nowrap select-none cursor-pointer ' +
  'border outline-none focus-visible:ring-2 focus-visible:ring-[var(--coral)]'

const VARIANTS = {
  default: 'bg-[var(--surface)] border-[var(--border)] text-[var(--ink-2)] hover:bg-[var(--bg-soft)]',
  cta:     'bg-[var(--coral)] border-transparent text-white hover:opacity-90 shadow-sm',
  active:  'bg-[var(--coral)] text-white border-transparent font-semibold',
  ghost:   'bg-transparent border-transparent text-[var(--ink-3)] hover:text-[var(--ink)] hover:bg-[var(--bg-soft)]',
}

const Pill = forwardRef(function Pill(
  { as: As = 'button', variant = 'default', iconOnly = false, className = '', children, ...props },
  ref,
) {
  const variantCls = VARIANTS[variant] ?? VARIANTS.default
  const sizeCls    = iconOnly ? 'w-8 h-8 p-0 justify-center' : ''
  return (
    <As ref={ref} className={`${BASE} ${variantCls} ${sizeCls} ${className}`} {...props}>
      {children}
    </As>
  )
})

export default Pill
